import { AvatarImg, LogoColor } from '@assets/images';
import { useAppDispatch, useAppSelector } from '@hooks';
import { AppBar, Avatar, Box, Menu, MenuItem, Toolbar } from '@mui/material';
import { showConfirm } from '@redux/actions';
import { FC, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Header.scss';
import { logout } from '@redux/actions/AuthService';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@utils/constants';
import { Button } from '@components/commons';

const Header: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAppSelector(state => state.auth);
  const { tenant } = useAppSelector(state => state.facility);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenSettings = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSettings = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    setAnchorEl(null);
    navigate(Routes.CHANGE_PASSWORD);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(
      showConfirm({
        title: 'auth.logout',
        content: 'auth.logout_confirm',
        onConfirm: () => dispatch(logout()),
      })
    );
  };

  return (
    <AppBar position='fixed' className='Header'>
      <Toolbar className='HeaderToolbar'>
        <div className='HeaderToolbar__logo'>
          <img
            className='logoMenu'
            src={LogoColor}
            alt='Logo'
            onClick={() => navigate(Routes.FACILITY)}
          />
        </div>
        <div className='HeaderToolbar__settings'>
          <Button
            title={tenant?.tenantName}
            typeName='tertiary'
            sx={{
              textTransform: 'none',
              fontSize: '25px',
              fontWeight: 700,
              mr: 1,
            }}
            onClick={() => {
              navigate(Routes.FACILITY);
            }}
          />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              ':hover': { cursor: 'pointer' },
            }}
            onClick={handleOpenSettings}
          >
            <Avatar alt={user?.accountId} src={AvatarImg} />
            <Button
              title={user?.accountId}
              typeName='text'
              sx={{ textTransform: 'none', fontSize: '20px' }}
            />
          </Box>
          <Menu
            id='HeaderMenu'
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleCloseSettings}
          >
            <MenuItem onClick={handleChangePassword}>
              {t('change_password.change_password_menu')}
            </MenuItem>
            <MenuItem onClick={handleLogout}>{t('auth.logout')}</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
